// src/router/dashboards.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['report_access_all', 'coordenador_operacional']


const dashboardsBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    }
]
export default [
  {
    path: '/dashboards/operacional/performance-realizada',
    name: 'DashboardOperacionalRealizado',
    component: () => import('@/views/Dashboard/PerformanceRealizada/DashboardOperacional.vue'),
    meta: {
      roles: ROLES,
      title: 'Dashboard Operacional',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalRealizado'
        }
      ]
    }
  },
  {
    path: '/dashboards/operacional/performance-prevista',
    name: 'DashboardOperacionalPrevisto',
    component: () => import('@/views/Dashboard/PerformancePrevista/DashboardOperacional.vue'),
    meta: {
      roles: ROLES,
      title: 'Dashboard Operacional',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalPrevisto'
        }
      ]
    }
  },
  {
    path: '/dashboards/operacional/indicadores-equipe',
    name: 'DashboardOperacionalIndicadoresEquipe',
    component: () => import('@/views/Dashboard/IndicadoresEquipe/DashboardOperacional.vue'),
    meta: {
      roles: ROLES,
      title: 'Dashboard Operacional',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalIndicadoresEquipe'
        }
      ]
    }
  },
  {
    path: '/dashboards/operacional/painel-gerencial',
    name: 'DashboardOperacionalPainelGerencial',
    component: () => import('@/views/Dashboard/PainelGerencial/DashboardOperacional.vue'),
    meta: {
      roles: ROLES,
      title: 'Dashboard Operacional',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalPainelGerencial'
        }
      ]
    }
  },
  {
    path: '/public/dashboards/operacional/performance-realizada',
    name: 'DashboardOperacionalRealizadoPublic',
    component: () => import('@/views/Dashboard/PerformanceRealizada/public/DashboardOperacional.vue'),
    meta: {
      title: 'Dashboard Operacional',
      layout: 'empty',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalRealizadoPublic'
        }
      ]
    }
  },
  {
    path: '/public/dashboards/operacional/performance-prevista',
    name: 'DashboardOperacionalPrevistoPublic',
    component: () => import('@/views/Dashboard/PerformancePrevista/public/DashboardOperacional.vue'),
    meta: {
      title: 'Dashboard Operacional',
      layout: 'empty',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalPrevistoPublic'
        }
      ]
    }
  },
  {
    path: '/public/dashboards/operacional/indicadores-equipe',
    name: 'DashboardOperacionalIndicadoresEquipePublic',
    component: () => import('@/views/Dashboard/IndicadoresEquipe/public/DashboardOperacional.vue'),
    meta: {
      title: 'Dashboard Operacional',
      layout: 'empty',
      // darkOnly: true,
      breadcrumb: [
        ...dashboardsBreadCrumb,
        {
          label: 'Dashboard Operacional',
          to: 'DashboardOperacionalIndicadoresEquipePublic'
        }
      ]
    }
  },
]
